// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"452":"7cbf90415fe24d33","728":"cae56d17f178cd47"}[chunkId] + ".css";
};